import React, { useState, useRef, useEffect, useCallback, useContext } from "react";
import { Button, Form, Table, Modal } from "react-bootstrap";
import { FaEye, FaDownload, FaReceipt, FaUpload, FaEdit } from "react-icons/fa";
import Papa from "papaparse";
import { useNavigate, useLocation } from "react-router-dom";
import { saveAs } from "file-saver";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL, UpdateInvoicePartialNetwork } from "../../api/api";
import pdfimage from "../images/pdf_downlaod.png";
import Swal from "sweetalert2";
import { AuthContext } from "../../context/AuthContext";
import { IconButton } from "@mui/material";
import { statusColor } from "../../utils/statusColor";

function PartialDetailPage() {
  const { user } = useContext(AuthContext);
  const [modalActionType, setModalActionType] = useState("");
  const isDisabled = user?.role === "NetworkSubAdmin"
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [batchRemark, setBatchRemark] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { batchData, } = location.state || {};
  const fileInputRef = useRef();
  const [invoices, setInvoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isGSTApplied, setIsGSTApplied] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [fileType, setFileType] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [existingInvoice, setExistingInvoice] = useState({
    url: null,
    fileName: null,
    fileType: null,
  });
  const [invoiceNo, setInvoiceNo] = useState("");
  const [caseCount, setCaseCount] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [caseCountError, setCaseCountError] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({
    invoiceNo: false,
    invoiceDate: false,
    invoiceAmount: false,
    caseCount: false,
    invoiceFile: false,
    remarks: {},
  });
  const [editValues, setEditValues] = useState({
    serviceCharges: "",
    repairCharges: "",
    chargesInclGST: "",
    remarks: "",
    remarkFile: null,
  });

  // console.log("Batch No:", batchNo);
  // console.log("Invoice Status:", invoiceStatus);
  // console.log("Full Data:", batchData);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(invoices.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInvoices = invoices.slice(indexOfFirstItem, indexOfLastItem);
  console.log(currentInvoices, 'currenttt', invoices)
  const selectedAAno = invoices.filter((invoice) => invoice.isChecked);

  // Calculate totals based on currently selected invoices
  const totalRepairCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const totalServiceCharges = selectedAAno.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const gstAmount = isGSTApplied
    ? (totalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const grossAmount = totalRepairCharges + totalServiceCharges;
  const finalAmount = isGSTApplied
    ? (grossAmount + parseFloat(gstAmount)).toFixed(2)
    : grossAmount.toFixed(2);

  const totalservicechargewithGST = (totalServiceCharges + parseFloat(gstAmount)).toFixed(2);
  const [originalCaseCount, setOriginalCaseCount] = useState("");
  const [originalInvoiceAmount, setOriginalInvoiceAmount] = useState("");
  const [rightSideCaseCount, setRightSideCaseCount] = useState("");
  const [rightSideInvoiceAmount, setRightSideInvoiceAmount] = useState("");

  useEffect(() => {
    if (!batchData) {
      navigate("/invoice");
      return;
    }
    const originalCaseCountVal = batchData.caseCount
      ? batchData.caseCount.toString()
      : "";
    const originalInvoiceAmountVal = batchData.invoiceAmount
      ? batchData.invoiceAmount.toString()
      : "";

    setOriginalCaseCount(originalCaseCountVal);
    setOriginalInvoiceAmount(originalInvoiceAmountVal);
    setRightSideCaseCount(originalCaseCountVal);
    setRightSideInvoiceAmount(originalInvoiceAmountVal);

    if (!batchData.gst || batchData.gst === "0.00") {
      setIsGSTApplied(false);
    } else {
      setIsGSTApplied(true);
    }
    setCaseCount(originalCaseCountVal);
    setInvoiceNo(batchData.invoiceNo || "");
    setInvoiceDate(batchData.invoiceDate || "");
    setInvoiceAmount(originalInvoiceAmountVal);

    if (batchData.invoice) {
      const fileName = batchData.invoice.split("/").pop() || "invoice.pdf";
      const fileType = fileName.split(".").pop()?.toLowerCase() || "";
      setExistingInvoice({
        url: batchData.invoice,
        fileName: fileName,
        fileType: fileType,
      });
      setFileType(fileType);
    }
  }, [batchData, navigate]);

  useEffect(() => {
    if (!batchData) return;
    setLoading(true);
    if (batchData.aaNo) {
      const aaNumbers = batchData.aaNo.split(",").map((val) => val.trim());
      Promise.all(
        aaNumbers.map((aaNo) =>
          fetch(`${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${aaNo}`)
            .then((response) => {
              if (!response.ok) {
                console.error(
                  `HTTP error for aaNo ${aaNo}: ${response.status}`
                );
                return { status: false, aA_Number: aaNo, dataItems: [] };
              }
              return response.json();
            })
            .then((responseData) => {
              if (!responseData || responseData.status === false) {
                return { status: false, aA_Number: aaNo, dataItems: [] };
              }
              const remarkFileUrl =
                responseData?.dataItems?.[0]?.remarkFileUrl || null;
              const remarks =
                responseData?.dataItems?.[0]?.remarks || null;
              return {
                status: responseData.status,
                aA_Number: aaNo,
                dataItems: Array.isArray(responseData.dataItems)
                  ? responseData.dataItems
                  : [],
                remarkFileUrl, remarks
              };
            })
            .catch((error) => {
              console.error(`Error fetching API data for ${aaNo}:`, error);
              return { status: false, aA_Number: aaNo, dataItems: [] };
            })
        )
      )
        .then((results) => {
          setApiData(results.filter((item) => item));
        })
        .catch((error) => {
          console.error("Error in Promise.all:", error);
          setApiData([]);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [batchData]);
  const hasAnySelected = invoices.some(inv => inv.isChecked);

  useEffect(() => {
    if (!batchData) return;
    const splitData = (key) =>
      batchData[key]
        ?.split(",")
        .map((val) => (val === "NULL" ? "-" : val.trim())) || [];
    const remainAAArray = splitData("remainAA");
    const utrArray = splitData("utr");
    const utrMap = {};
    remainAAArray.forEach((aa, i) => {
      if (aa && aa !== "-") utrMap[aa] = utrArray[i] || "-";
    });
    const invoicesArray = splitData("aaNo").map((_, i) => ({
      aA_Number: splitData("aaNo")[i],
      imeiNumber: splitData("imeiNo")[i],
      creationDate: batchData.creationDate || "",
      closureDate: batchData.closureDate || "",
      customerName: splitData("customerName")[i],
      serviceType: splitData("serviceType")[i],
      brand: splitData("brand")[i],
      makeModel: splitData("makeModel")[i],
      repairCharges: splitData("repairCharges")[i]
        ? parseFloat(splitData("repairCharges")[i]).toFixed(2)
        : "0.00",
      serviceCharges: splitData("serviceCharges")[i]
        ? parseFloat(splitData("serviceCharges")[i]).toFixed(2)
        : "0.00",
      chargesInclGST: splitData("chargesInclGST")[i]
        ? parseFloat(splitData("chargesInclGST")[i]).toFixed(2)
        : "0.00",
      total: splitData("total")[i]
        ? parseFloat(splitData("total")[i]).toFixed(2)
        : "0.00",
      invoiceStatus: batchData.invoiceStatus || "-",
      networkAndFinanceStatus: splitData("networkAndFinanceStatus")[i],
      uniquePartial: batchData.uniquePartial,
      sellingPartner: splitData("sellingPartner")[i],
      batchNo: batchData.batchNo || "",
      isChecked: true,
      remarks: splitData("remarks")[i] || "",
      remarkFile: batchData.remarkFile || null,
      utrNo: utrMap[splitData("aaNo")[i]] || "-",
    }));
    //   setInvoices(invoicesArray);
    // }, [batchData]);


    // Step 1: Merge localStorage edits first
    const storedInvoices = JSON.parse(localStorage.getItem("invoices") || "[]");

    const mergedWithLocal = invoicesArray.map((invoice) => {
      const stored = storedInvoices.find(
        (item) => item.aA_Number === invoice.aA_Number
      );

      return stored
        ? {
          ...invoice,
          serviceCharges: stored.serviceCharges,
          repairCharges: stored.repairCharges,
          chargesInclGST: stored.chargesInclGST,
          total: stored.total,
          remarks: stored.remarks || invoice.remarks,
          remarkFileUrl: stored.remarkFile || invoice.remarkFileUrl,
        }
        : invoice;
    });

    const mergedWithApi = mergedWithLocal.map((invoice) => {
      const apiMatch = apiData?.find(
        (apiItem) => apiItem?.aA_Number === invoice.aA_Number
      );
      if (!apiMatch) return invoice;

      const apiRemarks =
        apiMatch?.dataItems?.[0]?.remarks || apiMatch?.remarks || invoice.remarks;
      const apiRemarkFile =
        apiMatch?.remarkFileUrl || invoice.remarkFileUrl || null;

      return {
        ...invoice,
        remarks: apiRemarks,
        remarkFileUrl: apiRemarkFile,
      };
    });

    setInvoices(mergedWithApi);
  }, [batchData, apiData]);

  const normalize = (value) =>
    (value ? value.toString().trim() : "").toLowerCase();

  const getRowClassName = useCallback(
    (invoice) => {
      if (!Array.isArray(apiData) || apiData.length === 0) return "row-red";
      const matchedData = apiData.find(
        (item) => item.aA_Number === invoice.aA_Number
      );
      if (!matchedData || matchedData.status === false) return "row-red";
      if (
        matchedData.status === true &&
        Array.isArray(matchedData.dataItems) &&
        matchedData.dataItems.length > 0
      ) {
        const dataItem = matchedData.dataItems[0];
        if (
          normalize(dataItem.serviceType) !== normalize(invoice.serviceType) ||
          normalize(dataItem.repairCharges) !==
          normalize(invoice.repairCharges) ||
          normalize(dataItem.serviceCharges) !==
          normalize(invoice.serviceCharges) ||
          normalize(dataItem.total) !== normalize(invoice.total) ||
          normalize(dataItem.imeiNumber) !== normalize(invoice.imeiNumber) ||
          normalize(dataItem.sellingPartner) !==
          normalize(invoice.sellingPartner)
        ) {
          return "row-yellow";
        }
        return "row-green";
      }
      return "row-red";
    },
    [apiData]
  );

  const getDifferencesData = (invoice) => {
    const matchedData = apiData.find(
      (item) => item.aA_Number === invoice.aA_Number
    );
    if (!matchedData || matchedData.status === false)
      return [{ field: "AA Number", table: invoice.aA_Number, api: "-" }];
    const dataItem = matchedData.dataItems[0] || {};
    const differences = [];
    if (normalize(dataItem.serviceType) !== normalize(invoice.serviceType)) {
      differences.push({
        field: "Service Type",
        table: invoice.serviceType || "-",
        api: dataItem.serviceType || "-",
      });
    }
    if (normalize(dataItem.imeiNumber) !== normalize(invoice.imeiNumber)) {
      differences.push({
        field: "IMEI Number",
        table: invoice.imeiNumber || "-",
        api: dataItem.imeiNumber || "-",
      });
    }
    if (
      normalize(dataItem.sellingPartner) !== normalize(invoice.sellingPartner)
    ) {
      differences.push({
        field: "Selling Partner",
        table: invoice.sellingPartner || "-",
        api: dataItem.sellingPartner || "-",
      });
    }
    if (
      normalize(dataItem.repairCharges) !== normalize(invoice.repairCharges)
    ) {
      differences.push({
        field: "Repair Charges",
        table: invoice.repairCharges || "-",
        api: dataItem.repairCharges || "-",
      });
    }
    if (
      normalize(dataItem.serviceCharges) !== normalize(invoice.serviceCharges)
    ) {
      differences.push({
        field: "Service Charges",
        table: invoice.serviceCharges || "-",
        api: dataItem.serviceCharges || "-",
      });
    }
    if (
      normalize(dataItem.chargesInclGST) !== normalize(invoice.chargesInclGST)
    ) {
      differences.push({
        field: "GST Charges",
        table: invoice.chargesInclGST || "-",
        api: dataItem.chargesInclGST || "-",
      });
    }
    if (normalize(dataItem.total) !== normalize(invoice.total)) {
      differences.push({
        field: "Total Amount",
        table: invoice.total || "-",
        api: dataItem.total || "-",
      });
    }
    return differences.length > 0 ? differences : [];
  };
  const handleDelete = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedInvoices = invoices.filter((_, i) => i !== index);
        setInvoices(updatedInvoices);

        Swal.fire("Deleted!", "Your record has been deleted.", "success");

        if (updatedInvoices.length === 0) {
          navigate("/invoice");
        }
      }
    });
  };

  const handleCheckboxChange = (invoiceId) => {
    setInvoices((prevInvoices) => {
      if (invoiceId === "all") {
        const allChecked = prevInvoices.every((invoice) => invoice.isChecked);
        return prevInvoices.map((invoice) => ({
          ...invoice,
          isChecked: !allChecked,
        }));
      }
      return prevInvoices.map((invoice) =>
        invoice.aA_Number === invoiceId
          ? { ...invoice, isChecked: !invoice.isChecked }
          : invoice
      );
    });
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const extension = file.name.split(".").pop().toLowerCase();
    if (
      existingInvoice.fileName &&
      file.name.toLowerCase() === existingInvoice.fileName.toLowerCase()
    ) {
      toast.error("This file is already associated with the invoice.");
      fileInputRef.current.value = "";
      return;
    }
    setFileType(extension);
    setUploadedFile(file);
    setFieldErrors((prev) => ({ ...prev, invoiceFile: false }));
    if (extension === "csv") {
      Papa.parse(file, {
        header: true,
        complete: (results) => {
          const row = results.data[0];
          setInvoiceNo(row["Invoice No"] || "");
          setInvoiceDate(row["Invoice Date"] || "");
          setInvoiceAmount(row["Invoice Amount"] || "");
          setCaseCount(row["Case Count"] || caseCount);
        },
        error: (err) => {
          console.error("CSV parsing error:", err);
          toast.error("Failed to read CSV file.");
        },
      });
    }
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleRemarkFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setEditValues((prev) => ({ ...prev, remarkFile: file }));
    }
  };

  const handleCloseModal = () => {
    setShowEditModal(false);
    setEditingInvoice(null);
    setEditValues({
      serviceCharges: "",
      repairCharges: "",
      chargesInclGST: "",
      remarks: "",
      remarkFile: null,
    });
    setFieldErrors((prev) => ({
      ...prev,
      remarks: { ...prev.remarks, [editingInvoice?.aA_Number]: false },
    }));
  };

  const handleSaveEdit = async (aA_Number) => {
    const parsedServiceCharges = parseFloat(editValues.serviceCharges);
    const parsedRepairCharges = parseFloat(editValues.repairCharges);
    const parsedChargesInclGST = parseFloat(editValues.chargesInclGST);
    const remarks = editValues.remarks?.trim() || "";
    const remarkFile = editValues.remarkFile;

    if (getDifferencesData(editingInvoice).length > 0 && !remarks) {
      setFieldErrors((prev) => ({
        ...prev,
        remarks: { ...prev.remarks, [aA_Number]: true },
      }));
      toast.error("Cannot proceed without a reason for mismatched data.");
      return;
    }

    const formattedServiceCharges = isNaN(parsedServiceCharges)
      ? "0.00"
      : parsedServiceCharges.toFixed(2);
    const formattedRepairCharges = isNaN(parsedRepairCharges)
      ? "0.00"
      : parsedRepairCharges.toFixed(2);
    const formattedChargesInclGST = isNaN(parsedChargesInclGST)
      ? "0.00"
      : parsedChargesInclGST.toFixed(2);
    const formattedTotal = (
      parsedServiceCharges +
      parsedRepairCharges +
      parsedChargesInclGST
    ).toFixed(2);

    setInvoices((prevInvoices) => {
      const updated = prevInvoices.map((invoice) =>
        invoice.aA_Number === editingInvoice.aA_Number
          ? {
            ...invoice,
            serviceCharges: formattedServiceCharges,
            repairCharges: formattedRepairCharges,
            chargesInclGST: formattedChargesInclGST,
            total: formattedTotal,
            remarks: remarks,
            remarkFile: remarkFile ? URL.createObjectURL(remarkFile) : invoice.remarkFile,
          }
          : invoice
      )
      localStorage.setItem("invoices", JSON.stringify(updated));

      return updated;
    });
    try {
      const formData = new FormData();
      formData.append("aano", editingInvoice?.aA_Number);
      formData.append("remark", editValues.remarks);
      formData.append("remarkFile", editValues.remarkFile);
      formData.append("RemarkBy", user.role);
      formData.append("BillingType", editingInvoice?.billingType || "billing");
      formData.append("Document", null);

      const response = await fetch(
        `${BASE_URL}/UpdateClaimRemarks`,
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.status) {
        alert("Remark updated successfully");
        toast.success("Remark updated successfully.");
        const refreshResponse = await fetch(
          `${BASE_URL}/GetGadgetCaseDetailsByAA?aaNumbers=${editingInvoice.aA_Number}`
        );

        if (refreshResponse.ok) {
          const refreshedData = await refreshResponse.json();

          setApiData((prev) => {
            const updated = prev.map((item) =>
              item.aA_Number === editingInvoice.aA_Number
                ? {
                  ...item,
                  ...refreshedData,
                  remarkFileUrl:
                    refreshedData?.dataItems?.[0]?.remarkFileUrl || null,
                  remarks:
                    refreshedData?.dataItems?.[0]?.remarks || null,
                }
                : item
            );
            return updated;
          });
        }
        handleCloseModal();
      } else {
        alert("Failed to update: " + (data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Network error: " + error.message);
    }
    handleCloseModal();
  };
  useEffect(() => {
    const storedInvoices = localStorage.getItem("invoices");
    if (storedInvoices) {
      setInvoices(JSON.parse(storedInvoices));
    }
  }, []);

  const isRowDisabled = (invoice) => {
    const allowedAA = getAllowedAANumbers();

    if (allowedAA.length === 0) return true;

    return !allowedAA.includes(invoice.aA_Number);
  };
  const getAllowedAANumbers = () => {
    const aaNumbers = currentInvoices
      .map(invoice => invoice.uniquePartial)
      .filter(Boolean);
    if (aaNumbers.length === 0) return [];

    return aaNumbers.flatMap(aaString =>
      aaString.split(",").map(aa => aa.trim())
    );
  };

  const handleEdit = (invoice) => {
    setEditingInvoice(invoice);
    setEditValues({
      serviceCharges: invoice.serviceCharges || "0.00",
      repairCharges: invoice.repairCharges || "0.00",
      chargesInclGST: invoice.chargesInclGST || "0.00",
      remarks: invoice.remarks || "",
      remarkFile: invoice.remarkFile || null,
    });
    setShowEditModal(true);
  };
  function parseInvoiceDate(dateStr) {
    if (!dateStr) return new Date();

    const parsed = Date.parse(dateStr);

    if (!isNaN(parsed)) {
      return new Date(parsed);
    }

    const cleaned = dateStr.replace("AM", " AM").replace("PM", " PM");
    const dateObj = new Date(cleaned);

    if (!isNaN(dateObj.getTime())) {
      return dateObj;
    }

    throw new Error("Invalid date format: " + dateStr);
  }
  const downloadCSV = () => {
    const headers = [
      "AANumber",
      "IMEINumber",
      // "CreationDate",
      // "ClosureDate",
      "CustomerName",
      "Brand",
      "MakeModel",
      "RepairCharges",
      "ServiceCharges (Pre GST)",
      "Total",
      "InvoiceStatus",
      // "Remarks",
      // "Remark File",
    ];

    const today = new Date().toLocaleDateString("en-GB");

    const data = selectedAAno.map((invoice) => ({

      aaNumber: invoice.aA_Number || "",
      imeiNumber: invoice.imeiNumber ? `="${invoice.imeiNumber}"` : "",
      // ClosureDate: (invoice.closureDate || "").split(" ")[0],
      // CreationDate: (invoice.creationDate || "").split(" ")[0],
      customerName: invoice.customerName || "",
      brand: invoice.brand || "",
      makeModel: invoice.makeModel || "",
      repairCharges: invoice.repairCharges || "0.00",
      serviceCharges: invoice.serviceCharges || "0.00",
      total: invoice.total || "0.00",
      invoiceStatus: invoice.networkAndFinanceStatus || "",

    }));

    const csv = Papa.unparse({
      fields: headers,
      data: data.map(row => Object.values(row)),
    }, {
      quotes: true,
      quoteChar: '"',
      delimiter: ',',
      newline: '\r\n'
    });

    const vendorName =
      selectedAAno?.[0]?.sellingPartner?.replace(/\s+/g, "_") || "invoice";

    const fileName = `${vendorName}_list.csv`;

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, fileName);
  };

  const handleViewClick = (aaNumber) => {
    sessionStorage.setItem('preserveInvoices', 'true');
    navigate("/invoice-template", { state: { aaNumber } });
  };

  const handleBackClick = () => {
    localStorage.removeItem("invoices");
    navigate(-1);
  };
  useEffect(() => {
    return () => {
      if (sessionStorage.getItem('preserveInvoices') !== 'true') {
        localStorage.removeItem("invoices");
      }
      sessionStorage.removeItem('preserveInvoices');
    };
  }, []);

  const handleDownloadInvoice = () => {
    const invoiceUrl = batchData?.invoice;
    if (!invoiceUrl) {
      toast.error("No invoice URL available for download.");
      return;
    }
    const fileName = invoiceUrl.split("/").pop() || "invoice.pdf";
    const link = document.createElement("a");
    link.href = invoiceUrl;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // Calculate left side totals based on selected invoices
  const selectedInvoices = invoices.filter((invoice) => invoice.isChecked && !isRowDisabled(invoice));

  const leftSideTotalRepairCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.repairCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideTotalServiceCharges = selectedInvoices.reduce((total, invoice) => {
    const cleanedAmount = invoice.serviceCharges?.toString().replace(/,/g, "");
    const amount = parseFloat(cleanedAmount);
    return total + (isNaN(amount) ? 0 : amount);
  }, 0);

  const leftSideGstAmount = isGSTApplied
    ? (leftSideTotalServiceCharges * 0.18).toFixed(2)
    : (0).toFixed(2);

  const leftSideGrossAmount = leftSideTotalRepairCharges + leftSideTotalServiceCharges;
  const leftSideFinalAmount = isGSTApplied
    ? (leftSideGrossAmount + parseFloat(leftSideGstAmount)).toFixed(2)
    : leftSideGrossAmount.toFixed(2);

  const leftSideTotalservicechargewithGST = (leftSideTotalServiceCharges + parseFloat(leftSideGstAmount)).toFixed(2);
  const leftSideCaseCount = selectedInvoices.length;

  const handleSubmit = async () => {
    // const selectedInvoices = invoices.filter((inv) => inv.isChecked);
    // const unselectedInvoices = invoices.filter((inv) => !inv.isChecked);

    const activeInvoices = invoices.filter((inv) => !isRowDisabled(inv));

    const selectedInvoices = activeInvoices.filter((inv) => inv.isChecked);
    const unselectedInvoices = activeInvoices.filter((inv) => !inv.isChecked);
    const selectedapproveinvoice = invoices.filter((inv) => inv.isChecked);

    if (selectedInvoices.length === 0 && unselectedInvoices.length === 0) {
      toast.error("Please select at least one invoice.");
      return;
    }

    if (selectedInvoices.length > 0) {
      const yellowRowsWithoutRemarks = selectedInvoices.filter(
        (invoice) =>
          getRowClassName(invoice) === "row-yellow" && !invoice.remarks?.trim()
      );
      if (yellowRowsWithoutRemarks.length > 0) {
        const aaNumbers = yellowRowsWithoutRemarks
          .map((inv) => inv.aA_Number)
          .join(", ");
        toast.error(
          `Cannot approve invoices with mismatched data without remarks. Please add remarks for AA Numbers: ${aaNumbers}.`
        );
        return;
      }
    }

    // Prepare FormData for selected invoices (Partial Approval)
    if (selectedInvoices.length > 0) {
      const extract = (key) =>
        invoices.map((item) => item[key] || "").join(", ");
      const formData = new FormData();
      formData.append("sellingPartner", extract("sellingPartner") || "");
      formData.append("aaNo", extract("aA_Number") || "");
      formData.append("imeiNo", extract("imeiNumber") || "");
      // formData.append("creationDate", extract("creationDate"));  // ✅ get from selectedInvoices
      // formData.append("closureDate", extract("closureDate"));
      formData.append("creationDate", new Date().toISOString()); // ✅ get from selectedInvoices
      formData.append("closureDate", new Date().toISOString());
      formData.append("customerName", extract("customerName") || "");
      formData.append("serviceType", extract("serviceType") || "");
      formData.append("brand", extract("brand") || "");
      formData.append("makeModel", extract("makeModel") || "");
      formData.append("repairCharges", extract("repairCharges") || "0.00");
      formData.append("serviceCharges", extract("serviceCharges") || "0.00");

      // formData.append("invoiceStatus", "Approve");
      formData.append("total", extract("total") || "0.00");
      // const activeInvoices = invoices.filter((inv) => !isRowDisabled(inv));
      // const activeUnselected = activeInvoices.filter((inv) => !inv.isChecked);

      const allSelected = unselectedInvoices.length === 0;
      formData.append("invoiceStatus", allSelected ? "Approved" : "")
      // formData.append("invoiceStatus", allSelected ? "Back" : "");

      formData.append("batchNo", batchData?.batchNo || "");
      formData.append("selectedService", "");
      formData.append(
        "totalRepairCharges",
        parseFloat(leftSideTotalRepairCharges).toFixed(2)
      );
      formData.append("totalServiceCharges", leftSideTotalservicechargewithGST);
      formData.append("finalAmount", parseFloat(leftSideFinalAmount).toFixed(2));
      formData.append("gst", leftSideGstAmount);
      formData.append("invoiceNo", invoiceNo || "");
      formData.append("invoiceDate", invoiceDate || "");
      formData.append("invoiceAmount", invoiceAmount || "0.00");
      // formData.append("invoice", existingInvoice?.url || "");
      const fileUrl = existingInvoice?.url || "";
      const fileName = fileUrl ? fileUrl.split("fileName=")[1] : "";

      formData.append("invoice", fileName);
      formData.append("vendorName", batchData?.vendorName || "");
      formData.append("caseCount", batchData?.caseCount || "");
      formData.append("remarks", extract("remarks") || "");
      formData.append("remarkFile", extract("remarkFile") || "");

      // ------- UniqueApproval → selected active AA numbers
      const uniqueApproval = selectedInvoices
        .filter((inv) => !isRowDisabled(inv))
        .map((inv) => inv.aA_Number || "")
        .filter(Boolean)
        .join(",");

      const uniquePartial = unselectedInvoices
        .filter((inv) => !isRowDisabled(inv))
        .map((inv) => inv.aA_Number || "")
        .filter(Boolean)
        .join(",");

      formData.append("UniqueApproval", uniqueApproval || "");
      formData.append("UniquePartial", uniquePartial || "");

      const previousStatusMap = invoices.reduce((acc, inv) => {
        if (inv.aA_Number && inv.networkAndFinanceStatus) {
          acc[inv.aA_Number] = inv.networkAndFinanceStatus;
        }
        return acc;
      }, {});

      console.log(previousStatusMap, 'previouss')

      const networkAndFinanceStatus = invoices
        .map((inv) => {
          const isSelected = selectedapproveinvoice.some(
            (sel) => sel.aA_Number === inv.aA_Number
          );

          if (isSelected) {
            if (isRowDisabled(inv)) {
              console.log(
                `Row ${inv.aA_Number} is selected but DISABLED → keeping previous status:`,
                previousStatusMap[inv.aA_Number]
              );
              return previousStatusMap[inv.aA_Number] || "Partially Approved";
            } else {
              return "Invoice Approved";
            }
          } else {
            return "Partially Approved";
          }
        })
        .join(",");

      formData.append("NetworkAndFinanceStatus", networkAndFinanceStatus);

      if (!formData.get("aaNo")) {
        toast.error("AA Numbers are required for partial approval.");
        return;
      }
      if (!formData.get("batchNo")) {
        toast.error("Batch Number is required for partial approval.");
        return;
      }
      if (
        !formData.get("invoiceNo") &&
        (uploadedFile || !existingInvoice.url)
      ) {
        toast.error("Invoice Number is required for partial approval.");
        return;
      }
      if (
        !formData.get("invoiceDate") &&
        (uploadedFile || !existingInvoice.url)
      ) {
        toast.error("Invoice Date is required for partial approval.");
        return;
      }
      if (
        !formData.get("invoiceAmount") &&
        (uploadedFile || !existingInvoice.url)
      ) {
        toast.error("Invoice Amount is required for partial approval.");
        return;
      }
      const parsedInvoiceAmount = parseFloat(invoiceAmount);
      const parsedFinalAmount = parseFloat(finalAmount);

      if (
        (uploadedFile || !existingInvoice.url) &&
        (!invoiceAmount.trim() ||
          isNaN(parsedInvoiceAmount) ||
          parsedInvoiceAmount <= 0)
      ) {
        toast.error("Invoice Amount must be a valid positive number.");
        return;
      }

      if (
        (uploadedFile || !existingInvoice.url) &&
        Math.abs(parsedInvoiceAmount - parsedFinalAmount) > 0.01
      ) {
        toast.error("Invoice Amount must exactly match Final Amount.");
        return;
      }
      try {
        setLoading(true);
        console.log("Sending FormData for Partial Approval:");
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }

        const response = await fetch(`${BASE_URL}/BackApproveFromNetwork`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        if (!response.ok) {
          console.error("API error for approval:", {
            status: response.status,
            statusText: response.statusText,
            responseBody: result,
          });
          toast.error(
            `Error in approval: ${result.message || "Unknown error"} (Status: ${response.status
            })`
          );
          return;
        }
        const aanoString = selectedInvoices.map((item) => item.aA_Number).join(",");

        const remarkFormData = new FormData();
        remarkFormData.append("AANo", aanoString);
        remarkFormData.append("Remark", "Batch Approved Partially");
        remarkFormData.append("BatchNo", batchData?.batchNo);
        remarkFormData.append("ByWhom", user?.role);
        try {
          const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
            method: "POST",
            body: remarkFormData,
          });
        } catch (remarkError) {
          console.error("Failed to update remarks:", remarkError);
        }
        toast.success("Selected invoices Approved successfully.");
        localStorage.removeItem("invoices");
        navigate("/partialApproval");
      } catch (error) {
        console.error(" approval failed:", {
          message: error.message,
          stack: error.stack,
          formData: Object.fromEntries(formData.entries()),
        });
        toast.error(
          `Partial approval failed: ${error.message}. Check console for details.`
        );
        return;
      }
    }
  };
  // const handleSaveRemark = async (actionType) => {
  //   try {
  //     const selected = invoices.filter((inv) => inv.isChecked);
  //     const aaNumbers = selected.map((inv) => inv.aA_Number).join(",");
  // 
  //     if (!aaNumbers) {
  //       console.warn("No AA Numbers found for remark update");
  //       return true;
  //     }
  //         let logsMessage = "";
  //   switch (actionType) {
  //     case "Approved":
  //       logsMessage = `${aaNumbers} ${selected.length > 1 ? "have" : "has"} been approved`;
  //       break;
  //     case "Saved":
  //       logsMessage = `Batch saved`;
  //       break;
  //     default:
  //       logsMessage = `${aaNumbers} action: ${actionType}`;
  //       break;
  //   }
  // 
  //     const formData = new FormData();
  //     formData.append("aA_Number", aaNumbers);
  //     formData.append("remarks", batchRemark || "");
  //     formData.append("remarkAndLogBy", user.role);
  //     formData.append("batchNo", batchData?.batchNo);
  //     // formData.append("logs", actionType === "Approved" ? "Batch Approved" : "Batch Saved");
  //     formData.append("logs", logsMessage);
  // 
  //     const res = await fetch(`${BASE_URL}/InsertLogsAndRemarksTracking`, {
  //       method: "POST",
  //       body: formData,
  //     });
  // 
  //     const data = await res.json();
  // 
  //     if (!res.ok || !data.status) {
  //       toast.error(data.message || `Failed to ${actionType} remark.`);
  //       return;
  //     }
  // 
  //     toast.success(`Remark ${actionType === "Approved" ? "submitted" : "saved"} successfully.`);
  //     setShowRemarkModal(false);
  // 
  //     if (actionType === "Approved") {
  //       handleSubmit();
  //     } else {
  //       handleSaveData();
  //     }
  //   } catch (err) {
  //     console.error("Remark update failed:", err);
  //     toast.error("Failed to update remark.");
  //   }
  // };

  const handleSaveData = async () => {
    const allInvoices = invoices;
    if (!allInvoices || allInvoices.length === 0) {
      toast.error("No invoices available to save.");
      return;
    }

    if (allInvoices.length > 0) {
      const yellowRowsWithoutRemarks = allInvoices.filter(
        (invoice) =>
          getRowClassName(invoice) === "row-yellow" && !invoice.remarks?.trim()
      );
      if (yellowRowsWithoutRemarks.length > 0) {
        const aaNumbers = yellowRowsWithoutRemarks
          .map((inv) => inv.aA_Number)
          .join(", ");
        toast.error(
          `Cannot approve invoices with mismatched data without remarks. Please add remarks for AA Numbers: ${aaNumbers}.`
        );
        return;
      }
    }

    // Prepare FormData for selected invoices (Partial Approval)
    if (allInvoices.length > 0) {
      const extract = (key) =>
        allInvoices.map((item) => item[key] || "").join(", ");
      const formData = new FormData();
      formData.append("sellingPartner", extract("sellingPartner") || "");
      formData.append("aaNo", extract("aA_Number") || "");
      formData.append("imeiNo", extract("imeiNumber") || "");
      // formData.append("creationDate", extract("creationDate"));  // ✅ get from selectedInvoices
      // formData.append("closureDate", extract("closureDate"));
      formData.append("creationDate", new Date().toISOString()); // ✅ get from selectedInvoices
      formData.append("closureDate", new Date().toISOString());
      formData.append("customerName", extract("customerName") || "");
      formData.append("serviceType", extract("serviceType") || "");
      formData.append("brand", extract("brand") || "");
      formData.append("makeModel", extract("makeModel") || "");
      formData.append("repairCharges", extract("repairCharges") || "0.00");
      formData.append("serviceCharges", extract("serviceCharges") || "0.00");

      // formData.append("invoiceStatus", "Approve");
      formData.append("total", extract("total") || "0.00");
      // const allSelected = unselectedInvoices.length === 0;
      formData.append("invoiceStatus", allInvoices ? "Back" : "");

      formData.append("batchNo", batchData?.batchNo || "");
      formData.append("selectedService", "");
      formData.append(
        "totalRepairCharges",
        parseFloat(leftSideTotalRepairCharges).toFixed(2)
      );
      formData.append("totalServiceCharges", leftSideTotalservicechargewithGST);
      formData.append("gst", leftSideGstAmount);
      formData.append("finalAmount", parseFloat(leftSideFinalAmount).toFixed(2));
      formData.append("caseCount", batchData.caseCount);
      formData.append("invoiceNo", invoiceNo || "");
      formData.append("invoiceDate", invoiceDate || "");
      formData.append("invoiceAmount", invoiceAmount || "0.00");
      formData.append("invoice", existingInvoice?.url || "");
      formData.append("vendorName", batchData?.vendorName || "");
      formData.append("Type", "Partial");

      formData.append("remarks", extract("remarks") || "");
      formData.append("remarkFile", extract("remarkFile") || "");
      if (!formData.get("aaNo")) {
        toast.error("AA Numbers are required for partial approval.");
        return;
      }
      if (!formData.get("batchNo")) {
        toast.error("Batch Number is required for partial approval.");
        return;
      }
      if (
        !formData.get("invoiceNo") &&
        (uploadedFile || !existingInvoice.url)
      ) {
        toast.error("Invoice Number is required for partial approval.");
        return;
      }
      if (
        !formData.get("invoiceDate") &&
        (uploadedFile || !existingInvoice.url)
      ) {
        toast.error("Invoice Date is required for partial approval.");
        return;
      }
      if (
        !formData.get("invoiceAmount") &&
        (uploadedFile || !existingInvoice.url)
      ) {
        toast.error("Invoice Amount is required for partial approval.");
        return;
      }
      // New: Strict validation for invoice amount matching final amount
      const parsedInvoiceAmount = parseFloat(invoiceAmount);
      const parsedFinalAmount = parseFloat(finalAmount);

      if (
        (uploadedFile || !existingInvoice.url) &&
        (!invoiceAmount.trim() ||
          isNaN(parsedInvoiceAmount) ||
          parsedInvoiceAmount <= 0)
      ) {
        toast.error("Invoice Amount must be a valid positive number.");
        return;
      }

      if (
        (uploadedFile || !existingInvoice.url) &&
        Math.abs(parsedInvoiceAmount - parsedFinalAmount) > 0.01
      ) {
        toast.error("Invoice Amount must exactly match Final Amount.");
        return;
      }
      try {
        setLoading(true);
        console.log("Sending FormData for Partial Approval:");
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }

        const response = await fetch(`${BASE_URL}/UpdateBackPartialData`, {
          method: "POST",
          body: formData,
        });

        const result = await response.json();
        if (!response.ok) {
          console.error("API error for approval:", {
            status: response.status,
            statusText: response.statusText,
            responseBody: result,
          });
          toast.error(
            `Error in approval: ${result.message || "Unknown error"} (Status: ${response.status
            })`
          );
          return;
        }
        // const aanoString = selectedInvoices.map((item) => item.aA_Number).join(",");
        const aanoString = allInvoices.map((item) => item.aA_Number).join(",");

        const remarkFormData = new FormData();
        remarkFormData.append("AANo", aanoString);
        remarkFormData.append("Remark", "Batch Saved");
        remarkFormData.append("BatchNo", batchData?.batchNo);
        remarkFormData.append("ByWhom", user?.role);
        try {
          const res = await fetch(`${BASE_URL}/UpdateRemarkAgainstBatch`, {
            method: "POST",
            body: remarkFormData,
          });
        } catch (remarkError) {
          console.error("Failed to update remarks:", remarkError);
        }
        toast.success("Selected invoices Saved successfully.");
        localStorage.removeItem("invoices");
        navigate("/partialApproval");
      } catch (error) {
        console.error(" approval failed:", {
          message: error.message,
          stack: error.stack,
          formData: Object.fromEntries(formData.entries()),
        });
        toast.error(
          `Partial approval failed: ${error.message}. Check console for details.`
        );
        return;
      }
    }
  };

  const isPdf = (url) => {
    return url.toLowerCase().includes(".pdf");
  };

  const getFileNameFromUrl = (url) => {
    const params = new URLSearchParams(url.split("?")[1]);
    return decodeURIComponent(params.get("fileName"));
  };



  // const isRowDisabled = (invoice) => {
  //   const allowedAA = getAllowedAANumbers();
  //   console.log(allowedAA, 'Allowed AAs');
  //   return !allowedAA.includes(invoice.aA_Number);
  // };
  const handleLOGSremarks = (aa_number) => {
    navigate(`/Remarks&Logs/${aa_number}`)
  }
  const allRowsChecked =
    invoices.length > 0 && invoices.every((invoice) => invoice.isChecked);
    
  const hasInvoiceApprovedStatus = () => {
    return invoices.some(invoice =>
      invoice.networkAndFinanceStatus === "Invoice Approved"
    );
  };
  return (
    <>
      <style>
        {`
          .row-red { background-color: #ffe6e6; color: #d32f2f; }
          .row-yellow { background-color: #fff9c4; }
          .row-green { background-color: #e8f5e9; }
          .approval-page-container { padding: 20px; max-width: 1212px; margin: 0 auto; }
          .batch_popup_upload {
            background-color: #8000d7; color: white; border: none;
            padding: 10px 16px; border-radius: 8px; font-weight: 500;
            font-size: 14px; display: flex; align-items: center; cursor: pointer;
          }
          .batch_popup_upload:hover { background-color: #6b00b8; }
          .table-container { overflow-x: auto; overflow-y: auto; max-height: 400px; width: 100%; }
          .network_table { min-width: 1200px; }
          .network_table th, .network_table td { padding: 8px; vertical-align: middle; white-space: nowrap; }
          .vendore_invoice_status { white-space: nowrap; }
        `}
      </style>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
      />
      {/* {showRemarkModal && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content custom-modal">
              <div className="modal-header">
                All selected cases will be <strong>{modalActionType}</strong>
                <button type="button" className="btn-close" onClick={() => setShowRemarkModal(false)}></button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter your remarks..."
                  value={batchRemark}
                  onChange={(e) => setBatchRemark(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowRemarkModal(false)}>Cancel</button>
                <button
                  className="btn btn-primary"
                  onClick={() => handleSaveRemark(modalActionType)}
                >
                  {modalActionType === "Approved" ? "Save Remark" : "Save Remark"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
      <div className="approval-page-container">
        <h2 className="mb-4">Partial Approval</h2>
        <div className="mt-4">
          <div className="netwrok_table_main_content">
            <div className="d-flex justify-content-between align-items-center gap-2 mb-3">
              <div className="d-flex flex-wrap gap-4 align-items-center">
                {batchData?.batchNo && (
                  <div className="fw-semibold">
                    <span>Batch No: </span>
                    <span className="text-primary">{batchData.batchNo}</span>
                  </div>
                )}
                {batchData?.vendorName && (
                  <div className="fw-semibold">
                    <span>Vendor: </span>
                    <span className="text-success">{batchData.vendorName}</span>
                  </div>
                )}
              </div>
              <div className="d-flex gap-2">
                {/* {existingInvoice.url && (
                  <button
                    className="batch_popup_upload"
                    onClick={handleDownloadInvoice}
                  >
                    <FaDownload />{" "}
                    <span className="ms-2">Download Invoice</span>
                  </button>
                )} */}
                <button className="batch_popup_upload" onClick={handleClick}>
                  <FaUpload />{" "}
                  <span className="ms-2">
                    {existingInvoice.url ? "Update Invoice" : "Upload Invoice"}
                  </span>
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  accept="*"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end text-end upload_file_ext_name mb-3">
              {existingInvoice.url && !uploadedFile && (
                <div style={{ fontWeight: "bold", color: "green", display: "flex", alignItems: "center", gap: "10px" }}>
                  <span
                    onClick={() => window.open(existingInvoice.url, "_blank")}
                    style={{ cursor: "pointer" }}>{getFileNameFromUrl(existingInvoice.url)}</span>
                  <span

                  >
                    {isPdf(existingInvoice.url) ? (
                      <img src={pdfimage} alt="PDF" style={{ width: "24px", height: "24px" }} />
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              )}

              {uploadedFile && fileType && (
                <div style={{ fontWeight: "bold", color: "green" }}>
                  Uploaded File: {uploadedFile.name} (Type: {fileType})
                </div>
              )}

              {fieldErrors.invoiceFile && (
                <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                  Please upload an invoice file.
                </div>
              )}
            </div>

            <div className="table-container mt-3">
              <Table className="bg-white text-center border-0 network_table">
                <thead
                  style={{
                    backgroundColor: "#EEF4FF",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  <tr className="text-dark fw-semibold table_th_border">
                    <th className="border-start d-flex gap-2">
                      <Form.Check
                        type="checkbox"
                        checked={
                          invoices.length > 0 &&
                          invoices.every((invoice) => invoice.isChecked)
                        }
                        onChange={() => handleCheckboxChange("all")}
                        disabled={invoices.some((inv) => isRowDisabled(inv))}
                      />
                      Select
                    </th>
                    <th>View</th>
                    <th>Edit</th>
                    <th className="border-start">Remarks</th>
                    <th style={{ whiteSpace: "nowrap" }}>AA No</th>
                    <th style={{ whiteSpace: "nowrap" }}>IMEI No</th>
                    {/* <th style={{ whiteSpace: "nowrap" }}>Creation Date</th> */}
                    {/* <th style={{ whiteSpace: "nowrap" }}>Closure Date</th> */}
                    <th style={{ whiteSpace: "nowrap" }}>Customer Name</th>
                    {/* <th style={{ whiteSpace: "nowrap" }}>Service Type</th> */}
                    <th style={{ whiteSpace: "nowrap" }}>Brand</th>
                    <th style={{ whiteSpace: "nowrap" }}>Make Model</th>
                    <th style={{ whiteSpace: "nowrap" }}>Repair Charges</th>
                    <th style={{ whiteSpace: "nowrap" }}>Service Charges(Pre GST)</th>
                    <th style={{ whiteSpace: "nowrap" }}>Total</th>
                    <th style={{ whiteSpace: "nowrap" }}>Invoice Status</th>
                    <th style={{ whiteSpace: "nowrap" }}>UTR No</th>
                    <th style={{ whiteSpace: "nowrap" }}>Mismatched Data</th>
                    <th style={{ whiteSpace: "nowrap" }}>Remarks</th>
                    <th style={{ whiteSpace: "nowrap" }}>Remarks File</th>
                    {/* <th className="border-end" style={{ whiteSpace: "nowrap" }}>
                      Action
                    </th> */}
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="19" className="text-center py-3">
                        Validating data...
                      </td>
                    </tr>
                  )}
                  {!loading &&
                    currentInvoices.map((invoice, index) => {
                      const disabled = isRowDisabled(invoice);
                      return (
                        // <tr
                        //   key={
                        //     invoice.aA_Number || `${invoice.aA_Number}-${index}`
                        //   }
                        //   className={`text-center border-bottom network_td_item ${getRowClassName(
                        //     invoice
                        //   )}`}
                        //   aria-label={
                        //     getRowClassName(invoice).replace("row-", "") + " row"
                        //   }
                        // >
                        <tr
                          key={invoice.id || `${invoice.aA_Number}-${index}`}
                          className={`text-center border-bottom network_td_item ${getRowClassName(invoice)} ${isRowDisabled(invoice) ? 'table-row-disabled' : ''}`}
                          style={{
                            opacity: isRowDisabled(invoice) ? 0.6 : 1,
                            backgroundColor: isRowDisabled(invoice) ? '#f2f2f2' : 'transparent',
                            pointerEvents: isRowDisabled(invoice) ? 'none' : 'auto'
                          }}
                        >
                          <td className="border-start align-middle">
                            <Form.Check
                              type="checkbox"
                              checked={invoice.isChecked}
                              onChange={() =>
                                handleCheckboxChange(invoice.aA_Number)
                              }
                              disabled={loading || isDisabled}
                            />
                          </td>
                          <td className="align-middle"
                            style={{ pointerEvents: "auto" }}
                          >
                            <IconButton
                              // onClick={() =>
                              //   navigate("/invoice-template", {
                              //     state: {
                              //       aaNumber: invoice.aA_Number,
                              //       invoiceData: invoice,
                              //     },
                              //   })
                              // }
                              onClick={() => handleViewClick(invoice.aA_Number)}

                            >
                              <FaEye
                                size={20}
                                className="text-purple review_fa_eye"
                                style={{ cursor: "pointer" }}
                              />
                            </IconButton>
                          </td>
                          <td className="align-middle">
                            {/* <FaEdit
                              size={20}
                              className="text-purple-600 review_fa_eye"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                if (!disabled) handleEdit(invoice);
                              }}
                              
                            /> */}
                            <td className="align-middle">
                              <button
                                onClick={() => {
                                  if (!disabled) handleEdit(invoice);
                                }}
                                disabled={loading || isDisabled}
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  cursor: loading || isDisabled ? "not-allowed" : "pointer"
                                }}
                              >
                                <FaEdit
                                  size={20}
                                  className="text-purple-600 review_fa_eye"
                                />
                              </button>
                            </td>

                          </td>
                          <td className="border-start align-middle">
                            <FaReceipt
                              size={20}
                              className="text-purple-600 review_fa_eye"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleLOGSremarks(invoice.aA_Number)}
                            />
                          </td>
                          <td className="align-middle">
                            {invoice.aA_Number || "-"}
                          </td>
                          <td className="align-middle">
                            {invoice.imeiNumber || "-"}
                          </td>

                          {/* <td className="align-middle">
                          {invoice.closureDate || "-"}
                        </td> */}
                          <td className="align-middle">
                            {invoice.customerName || "-"}
                          </td>
                          <td className="align-middle">{invoice.brand || "-"}</td>
                          <td className="align-middle">
                            {invoice.makeModel || "-"}
                          </td>
                          <td className="align-middle">
                            {invoice.repairCharges || "0.00"}
                          </td>
                          <td className="align-middle">
                            {invoice.serviceCharges || "0.00"}
                          </td>
                          <td className="align-middle">
                            {invoice.total || "0.00"}
                          </td>
                          {/* <td className="align-middle">
                            <span className="vendore_invoice_status px-3 py-1 rounded-pill">
                              {invoice.networkAndFinanceStatus || "-"}
                            </span>
                          </td> */}
                          <td className="align-middle">
                            {(() => {
                              const displayStatus = invoice.utrNo && invoice.utrNo.trim() !== "-" && invoice.utrNo.trim() !== ""
                                ? "Payment Done"
                                : invoice.networkAndFinanceStatus || "-";
                              const statusStyle = statusColor[displayStatus.trim()] || {
                                color: "#6B7280",
                                backgroundColor: "#F3F4F6",
                              };
                              return (
                                <span
                                  className="vendore_invoice_status px-3 py-1 rounded-pill"
                                  style={{
                                    backgroundColor: statusStyle.backgroundColor,
                                    color: statusStyle.color,
                                    border: `1px solid ${statusStyle.color}`,
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    whiteSpace: "nowrap"
                                  }}
                                >
                                  {displayStatus}
                                </span>
                              );
                            })()}
                          </td>
                          <td className="align-middle">
                            {invoice.utrNo || "-"}
                          </td>
                          <td
                            className="align-middle position-relative"
                            onMouseEnter={() => setHoveredRow(index)}
                            onMouseLeave={() => setHoveredRow(null)}
                          >
                            {getDifferencesData(invoice).length > 0
                              ? "Mismatch"
                              : "Valid"}
                            {hoveredRow === index &&
                              getDifferencesData(invoice).length > 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: "-18%",
                                    transform: "translateX(-50%)",
                                    zIndex: 1000,
                                    backgroundColor: "#fff",
                                    border: "1px solid #ddd",
                                    padding: "10px",
                                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                    minWidth: "300px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <table className="table table-sm table-bordered mb-0">
                                    <thead>
                                      <tr>
                                        <th>Field</th>
                                        <th>Excel Data</th>
                                        <th>System Data</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {getDifferencesData(invoice).map(
                                        (diff, i) => (
                                          <tr key={i}>
                                            <td>{diff.field}</td>
                                            <td>{diff.table}</td>
                                            <td>{diff.api}</td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                          </td>
                          <td className="align-middle">
                            {invoice.remarks || "no remarks"}
                          </td>
                          <td className="align-middle border-end">
                            {invoice.remarkFileUrl ? (
                              <a
                                href={invoice.remarkFileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#8000d7",
                                  textDecoration: "underline",
                                }}
                              >
                                View File
                              </a>
                            ) : (
                              "-"
                            )}
                          </td>
                          {/* <td className="align-middle border-end">
                            <FaTrash
                              size={20}
                              style={{ cursor: "pointer", color: "red" }}
                              onClick={() => handleDelete(index)}
                            />
                          </td> */}
                        </tr>
                      )
                    })}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center pagination-container mt-3">
              <button
                className="btn btn-outline-primary"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="page-info">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
            <div className="row justify-content-between align-items-start mt-2">
              {/* Left Column */}
              {/* Left Column */}
              <div className="col-6">
                {/* GST Toggle */}
                <div className="border rounded p-2 mt-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="fw-bold ms-2">
                      <span>GST</span>
                    </div>
                    <div className="d-flex gap-3">
                      <label className="registration_kc_radio">
                        <input
                          type="radio"
                          name="gstApplied"
                          checked={isGSTApplied}
                          onChange={() => setIsGSTApplied(true)}
                        />
                        <span className="registration_applied_yes">Yes</span>
                      </label>
                      <span className="mx-1">/</span>
                      <label className="registration_kc_radio">
                        <input
                          type="radio"
                          name="gstApplied"
                          checked={!isGSTApplied}
                          onChange={() => setIsGSTApplied(false)}
                        />
                        <span className="registration_applied_yes">No</span>
                      </label>
                    </div>
                  </div>
                </div>

                <h5 style={{ textAlign: "center", textDecoration: "underline" }}>Partial Invoice Details</h5>
                <div
                  style={{
                    backgroundColor: "#eef4ff",
                    marginTop: "8px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    padding: "16px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <span style={{ fontWeight: 600, color: "gray" }}>
                    Total no of selected invoices:
                  </span>
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    {leftSideCaseCount}
                  </span>
                </div>

                {/* Amount Summary */}
                <div
                  className="batch_popup_gross_ammount mt-2 w-100"
                  style={{ backgroundColor: "#eef4ff" }}
                >
                  <div className="d-flex justify-content-between batch_popup_amount">
                    <div className="fw-bold batch_gross">Total Repair Charges</div>
                    <div className="text-end batch_amount_to_fix">
                      ₹ {parseFloat(leftSideTotalRepairCharges).toFixed(2)}
                    </div>
                  </div>

                  <div className="d-flex justify-content-between batch_popup_amount">
                    <div className="fw-bold batch_gross">Total Service Charges</div>
                    <div className="d-flex align-items-center">
                      <div className="batch_amount_to_fix">
                        ₹ {leftSideTotalservicechargewithGST} ({isGSTApplied ? "incl GST 18%" : "excl GST"})
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between batch_popup_amount">
                    <div className="fw-bold batch_gross">Total Amount</div>
                     <div className="batch_amount_to_fix" style={{ fontSize: "14px" }}>
                    <b>₹ {leftSideFinalAmount}</b>
                  </div>
                  </div>

                  <div className="mt-2 d-flex justify-content-end">
                    <span className="fw-semibold text-secondary" style={{ fontSize: "13px" }}>
                      {isGSTApplied
                        ? `GST Amount Added: ₹${leftSideGstAmount}`
                        : `No GST Applied (₹${leftSideGstAmount})`}
                    </span>
                  </div>
                </div>
              </div>

              {/* Right Column (Form) */}
              <div className="col-6" style={{ backgroundColor: "#eef4ff", marginTop: "1rem" }}>
                <form className="mt-4 invoice_form">
                  <h5 style={{ textAlign: "center", textDecoration: "underline" }}>Invoice Details</h5>
                  <div className="row align-items-center">

                    {/* Case Count */}
                    <div className="d-flex align-items-center mb-3">
                      <label className="fw-semibold me-2" style={{ width: "200px" }}>
                        Case Count
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark ${(uploadedFile || !existingInvoice.url) &&
                          (fieldErrors.caseCount || caseCountError)
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder="Case Count"
                        value={caseCount}
                        onChange={(e) => {
                          const value = e.target.value;
                          setCaseCount(value);
                          if (uploadedFile || !existingInvoice.url) {
                            const parsedValue = parseInt(value);
                            setFieldErrors((prev) => ({
                              ...prev,
                              caseCount:
                                !value.trim() || isNaN(parsedValue) || parsedValue <= 0,
                            }));
                            if (
                              value.trim() &&
                              !isNaN(parsedValue) &&
                              parsedValue > 0
                            ) {
                              if (parsedValue !== selectedAAno.length) {
                                setCaseCountError(
                                  "Case Count must match the total number of selected invoices."
                                );
                              } else {
                                setCaseCountError("");
                              }
                            } else {
                              setCaseCountError("");
                            }
                          }
                        }}
                        disabled
                      />
                    </div>
                    {(uploadedFile || !existingInvoice.url) && fieldErrors.caseCount && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        Case Count must be a valid positive number.
                      </div>
                    )}
                    {(uploadedFile || !existingInvoice.url) && caseCountError && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        {caseCountError}
                      </div>
                    )}

                    {/* Invoice No */}
                    <div className="d-flex align-items-center mb-3">
                      <label className="fw-semibold me-2" style={{ width: "200px" }}>
                        Invoice No
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark ${(uploadedFile || !existingInvoice.url) && fieldErrors.invoiceNo
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder="Invoice No"
                        value={invoiceNo}
                        onChange={(e) => {
                          const value = e.target.value;
                          setInvoiceNo(value);
                          if (uploadedFile || !existingInvoice.url) {
                            setFieldErrors((prev) => ({
                              ...prev,
                              invoiceNo: !value.trim(),
                            }));
                          }
                        }}
                        // disabled
                         disabled={loading || isDisabled || hasInvoiceApprovedStatus()}

                      />
                    </div>
                    {(uploadedFile || !existingInvoice.url) && fieldErrors.invoiceNo && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        Invoice No is required.
                      </div>
                    )}

                    {/* Invoice Date */}
                    <div className="d-flex align-items-center mb-3">
                      <label className="fw-semibold me-2" style={{ width: "200px" }}>
                        Invoice Date
                      </label>
                      <input
                        type="date"
                        className={`form-control border-dark ${(uploadedFile || !existingInvoice.url) && fieldErrors.invoiceDate
                          ? "is-invalid"
                          : ""
                          }`}
                        value={invoiceDate ? invoiceDate.split("T")[0] : ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          setInvoiceDate(value);
                          if (uploadedFile || !existingInvoice.url) {
                            setFieldErrors((prev) => ({
                              ...prev,
                              invoiceDate:
                                !value.trim() ||
                                value > new Date().toISOString().split("T")[0],
                            }));
                          }
                        }}
                        disabled
                        max={new Date().toISOString().split("T")[0]}
                      />
                    </div>
                    {(uploadedFile || !existingInvoice.url) &&
                      fieldErrors.invoiceDate && (
                        <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                          Invoice Date is required and cannot be future.
                        </div>
                      )}

                    {/* Invoice Amount */}
                    <div className="d-flex align-items-center mb-3">
                      <label className="fw-semibold me-2" style={{ width: "200px" }}>
                        Invoice Amount
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark ${(uploadedFile || !existingInvoice.url) &&
                          (fieldErrors.invoiceAmount || amountError)
                          ? "is-invalid"
                          : ""
                          }`}
                        placeholder="Enter Amount"
                        value={invoiceAmount}
                        onChange={(e) => {
                          const enteredAmount = e.target.value;
                          setInvoiceAmount(enteredAmount);

                          const parsedAmount = parseFloat(enteredAmount);
                          const parsedFinalAmount = parseFloat(finalAmount);

                          const shouldValidate =
                            uploadedFile || !existingInvoice.url;

                          if (shouldValidate) {
                            const isInvalidAmount =
                              !enteredAmount.trim() ||
                              isNaN(parsedAmount) ||
                              parsedAmount <= 0;

                            setFieldErrors((prev) => ({
                              ...prev,
                              invoiceAmount: isInvalidAmount,
                            }));

                            if (!isInvalidAmount) {
                              if (
                                !isNaN(parsedFinalAmount) &&
                                Math.abs(parsedAmount - parsedFinalAmount) > 0.01
                              ) {
                                setAmountError("Invoice Amount must match Total Amount.");
                              } else {
                                setAmountError("");
                              }
                            } else {
                              setAmountError("");
                            }
                          } else {
                            setFieldErrors((prev) => ({
                              ...prev,
                              invoiceAmount: false,
                            }));
                            setAmountError("");
                          }
                        }}
                        disabled
                      />
                    </div>
                    {(uploadedFile || !existingInvoice.url) &&
                      fieldErrors.invoiceAmount && (
                        <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                          Invoice Amount must be a valid positive number.
                        </div>
                      )}
                    {(uploadedFile || !existingInvoice.url) && amountError && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        {amountError}
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>

            <div className="d-flex mt-4 justify-content-center align-items-center flex-wrap gap-3">
              <Button
                onClick={downloadCSV}
                className="d-flex align-items-center"
                style={{
                  backgroundColor: "rgb(248, 238, 255)",
                  border: "1px solid #8000d7",
                  padding: "10px 50px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "#8000d7",
                }}
              >
                <FaDownload />
                <span className="ms-2">Download</span>
              </Button>
              <button
                onClick={handleSaveData}
                className="btn btn-primary d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 50px",
                  borderRadius: "8px",
                  fontWeight: "500",
                  fontSize: "16px",
                  color: "white",
                }}
                disabled={loading || isDisabled || !hasAnySelected || !allRowsChecked}
              >
                {loading ? "Saving..." : "Save"}
              </button>
              <Button
                onClick={handleSubmit}
                className="d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "white",
                }}
                disabled={loading || isDisabled || !hasAnySelected}
              >
                <span>{loading ? "Processing..." : "Approve"}</span>
              </Button>
              {/* <Button
                onClick={() => handleSendAction("Send Partial")}
                className="d-flex align-items-center"
                style={{
                  backgroundColor: "#8000d7",
                  border: "none",
                  padding: "10px 16px",
                  fontWeight: "bold",
                  fontSize: "16px",
                  color: "white",
                }}
                disabled={loading}
              >
                <span>{loading ? "Submitting..." : "Partial Or Back"}</span>
              </Button> */}
            </div>
          </div>
        </div>
      </div>

      <Modal show={showEditModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton style={{ backgroundColor: "#EBF3FF" }}>
          <Modal.Title>
            Edit Invoice (AA No: {editingInvoice?.aA_Number})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Repair Charges</Form.Label>
              <Form.Control
                type="number"
                name="repairCharges"
                value={editValues.repairCharges}
                onChange={handleEditInputChange}
                min="0"
                step="0.01"
                placeholder="Enter Repair Charges"
                size="lg"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Logistics and Repair Support Fees</Form.Label>
              <Form.Control
                type="number"
                name="serviceCharges"
                value={editValues.serviceCharges}
                onChange={handleEditInputChange}
                min="0"
                step="0.01"
                size="lg"
                placeholder="Enter Services"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="remarks"
                value={editValues.remarks}
                onChange={handleEditInputChange}
                placeholder="Enter Remarks"
                className={
                  fieldErrors.remarks[editingInvoice?.aA_Number]
                    ? "is-invalid"
                    : ""
                }
              />
              {fieldErrors.remarks[editingInvoice?.aA_Number] && (
                <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                  Remarks are required for mismatched data.
                </div>
              )}
            </Form.Group>
            <Form.Group controlId="formFile" className="mb-0">
              <Form.Label
                htmlFor="fileUpload"
                className="btn btn-secondary mb-0"
                style={{ backgroundColor: "#8000d7", border: "none" }}
              >
                Upload Remark File
              </Form.Label>
              <Form.Control
                type="file"
                id="fileUpload"
                name="remarkFile"
                onChange={handleRemarkFileChange}
                style={{ display: "none" }}
              />
              {editValues.remarkFile && (
                <div
                  className="mt-2"
                  style={{ fontWeight: "bold", color: "green" }}
                >
                  Selected File: {editValues.remarkFile.name || editValues.remarkFile}
                </div>
              )}
              {editingInvoice?.remarkFile && !editValues.remarkFile && (
                <div
                  className="mt-2"
                  style={{ fontWeight: "bold", color: "green" }}
                >
                  Existing File: <a href={editingInvoice.remarkFile} target="_blank" rel="noopener noreferrer">View Current File</a>
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => handleSaveEdit(editingInvoice?.aA_Number)}
            style={{ backgroundColor: "#8000d7", border: "none" }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PartialDetailPage;


